export default __webpack_public_path__ + "static/media/product-overview-bg.b088486f.webp";